module.exports = __webpack_public_path__ + "static/media/spe_designsystem_fg.de8c2a26.png";